<p-panel header="Authorization Details" [toggleable]="true" [collapsed]="isPASComplete" toggler="header">
  <ng-template #headericons let-collapsed>
    <i class="pi pi-chevron-down duration-150" [class]="{ 'rotate-180': !collapsed }"></i>
  </ng-template>
    @if (authState) {
      <div
        class="grid grid-cols-12 gap-4 p-fluid p-form-widget p-form-view-data p-form-aligned"
        >
        <div class="col-span-6">
          <div class="field">
            <label data-test-id="auth-type-label">Type of Authorization: </label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ authState.facilityType.description }}
              </div>
            </div>
          </div>
          <div class="field">
            <label data-test-id="clinical-category-label">Clinical Category: </label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ clinicalCategory }}
              </div>
            </div>
          </div>
          <div class="field">
            <label data-test-id="referral-source-label">Acute Referral Source: </label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ authState.referralSource.description }}
              </div>
            </div>
          </div>
          <div
            class="field"
            [class]="{ 'inactive-label': !authState.referralFacilityNPI }"
            >
            <label data-test-id="facility-npi-label">Acute (Prior) Referral Facility NPI: </label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ authState.referralFacilityNPI || '--' }}
              </div>
            </div>
          </div>
          <div class="field">
            <label data-test-id="unknown-npi-label">Unknown Acute (Prior) Referral Facility NPI: </label>
            <div class="p-field-value flex items-center">
              <div class="readonly-field p-field-checkbox-container">
                <p-checkbox
                  data-test-id="unknown-npi-checkbox"
                  [ngModel]="!authState.referralFacilityNPI"
                  [binary]="true"
                  [disabled]="true"
                ></p-checkbox>
              </div>
            </div>
          </div>
          <div
            class="field"
            [class]="{ 'inactive-label': !authState.referralFacilityName }"
            >
            <label data-test-id="facility-name-label">Acute (Prior) Referral Facility Name: </label>
            <div class="p-field-value">
              <div class="readonly-field whitespace-normal break-words">
                {{ authState.referralFacilityName || '--' }}
              </div>
            </div>
          </div>
          <div class="field">
            <label data-test-id="unknown-facility-name-label">Unknown Acute (Prior) Referral Facility Name: </label>
            <div class="p-field-value flex items-center">
              <div class="readonly-field p-field-checkbox-container">
                <p-checkbox
                  data-test-id="unknown-facility-name-checkbox"
                  [ngModel]="!authState.referralFacilityName"
                  [binary]="true"
                  [disabled]="true"
                ></p-checkbox>
              </div>
            </div>
          </div>
          <div *accessView="['PACIMAuthorization.ReferralSourceContactName.Read']">
            <div class="field">
              <label
                data-test-id="contact-name-label"
                [class.field-required]="!isInternal"
                >
                Acute (Prior) Hospital Direct Contact Name:
              </label>
              <div class="p-field-value">
                <div class="readonly-field">
                  {{ authState.referralSourceContactName || '--'}}
                </div>
              </div>
            </div>
            <div class="field">
              <label
                data-test-id="referral-phone-label"
                [class.field-required]="!isInternal"
                >
                Acute (Prior) Hospital Direct Phone Number:
              </label>
              <div class="p-field-value">
                <div class="readonly-field">
                  {{ authState.referralSourcePhone | phoneNumber }}
                </div>
              </div>
            </div>
            <div class="field">
              <label
                data-test-id="referral-fax-label"
                [class.field-required]="!isInternal"
                >
                Acute (Prior) Hospital Direct Fax Number:
              </label>
              <div class="p-field-value">
                <div class="readonly-field">
                  {{ authState.referralSourceFax | phoneNumber }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-span-6">
          @if (isInternal) {
            <div class="field">
              <label data-test-id="request-received-date-label">Date/Time Request Received: </label>
              <div class="p-field-value">
                <div class="readonly-field">
                  {{ authState.authorizationProduct?.requestReceivedDate | utcToLocal: 'MM/dd/yyyy hh:mm:ss a' }}
                </div>
              </div>
            </div>
          }
          <div class="field">
            <label data-test-id="admit-date-label">Anticipated Admit Date: </label>
            <div class="p-field-value">
              <!-- TODO Replace with a simple <div> tag with date pipe once the admitDate format is standardized. -->
              <div class="readonly-field">
                {{ authState.admitDate?.indexOf('Z') > 0
                ? (authState.admitDate | date: 'MM/dd/yyyy':'UTC')
                : (authState.admitDate | date:'MM/dd/yyyy')
                }}
              </div>
            </div>
          </div>
          @if (authState.memberCurrentlyAdmitted !== undefined && authState.memberCurrentlyAdmitted !== null) {
            <div
              class="field"
              >
              <label data-test-id="member-admitted-label"> Is the member currently admitted to a {{ authState.facilityType.description }}? </label>
              <div class="p-field-value flex items-center">
                <div class="pl-2">
                  <div class="flex items-center">
                    <p-radio-button
                      class="p-radioButton-disabled"
                      value="yes"
                      inputId="memberAdmitted_yes"
                      data-test-id="member-is-admitted-radioButton"
                      [ngModel]="authState.memberCurrentlyAdmitted ? 'yes' : 'no'"
                      [disabled]="true"
                    />
                    <label for="memberAdmitted_yes" class="ml-2" data-test-id="member-is-admitted-label">Yes</label>
                  </div>
                  <div class="flex items-center">
                    <p-radio-button
                      class="p-radioButton-disabled"
                      value="no"
                      inputId="memberAdmitted_no"
                      data-test-id="member-is-not-admitted-radioButton"
                      [ngModel]="authState.memberCurrentlyAdmitted ? 'yes' : 'no'"
                      [disabled]="true"
                    />
                    <label for="memberAdmitted_no" class="ml-2" data-test-id="member-is-not-admitted-label">No</label>
                  </div>
                  @if (authState.memberCurrentlyAdmitted) {
                    <div class="mt-1">
                      <p-message
                        class="instruction-message"
                        severity="warn"
                        [text]="isPacCommercial ? memberAdmittedCommMsg : memberAdmittedMaMsg"
                      ></p-message>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
          @if (authState.memberDischargeDate) {
            <div>
              <div class="field">
                <label data-test-id="discharge-date-label">Member's Discharge Date: </label>
                <div class="p-field-value">
                  <div class="readonly-field">
                    {{ authState.memberDischargeDate | utcDateWithoutTimeZone: 'MM/dd/yyyy' }}
                  </div>
                </div>
              </div>
              <div class="field">
                <label data-test-id="discharge-disposition-label">Discharge Disposition: </label>
                <div class="p-field-value">
                  <div class="readonly-field">
                    {{ authState.dischargeDisposition.description }}
                  </div>
                </div>
              </div>
              <div class="field">
                <label data-test-id="discharge-rationale-label">Discharge Rationale: </label>
                <div class="p-field-value">
                  <div class="readonly-field">
                    {{ authState.dischargeRationale.description }}
                  </div>
                </div>
              </div>
            </div>
          }
          <div class="field">
            <label data-test-id="urgency-label">Urgency: </label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ authState.urgency.description }}
              </div>
            </div>
          </div>
          @if (isInternal) {
            <div class="field">
              <label data-test-id="request-source-label">Request Source: </label>
              <div class="p-field-value">
                <div class="readonly-field">
                  {{ authState.requestSource.description }}
                </div>
              </div>
            </div>
            <div class="field">
              <label data-test-id="requestor-label">Requestor: </label>
              <div class="p-field-value">
                <div class="readonly-field">
                  {{ authState.requestor.description }}
                </div>
              </div>
            </div>
            @if (authState.memberRepresentative) {
              <div class="field">
                <label data-test-id="member-representative-label">Member Representative: </label>
                <div class="p-field-value">
                  <div class="readonly-field">
                    {{ authState.memberRepresentative }}
                  </div>
                </div>
              </div>
            }
          }
        </div>
      </div>
    }
</p-panel>
